// extracted by mini-css-extract-plugin
export default {"container":"foodSection_container__gmzJy","name":"foodSection_name__ApmsM","separator":"foodSection_separator__uTpqa","items":"foodSection_items__4bpPG"};